import React from "react";
import { Grid, GridRow, GridColumn } from "semantic-ui-react";
import { useParams, Link } from "react-router-dom";
import recipesData from "../recipesData.json";
import recipeUp from './img/decorative-recipe-up.png';
import recipeDown from './img/decorative-recipe-down.png';
import drinkingRabbit from './img/drinking-rabbit.png';
import decorativeHeart from './img/heart-decorative.png';

const CocktailPage = () => {
  const { id } = useParams();
  const cocktailId = id;
  const recipe = recipesData.recipes.find(recipe => recipe.id == cocktailId);

  const containerStyle = {
    /*backgroundImage: `url(${recipe.urlBackground})`,
    backgroundSize: "cover", 
    backgroundPosition: "center",*/
  };

  let tequilaComplexityClass = "";
  if (recipe.complexity === "Easy") {
    tequilaComplexityClass = "easy-text";
  } else if (recipe.complexity === "Medium") {
    tequilaComplexityClass = "medium-text";
  } else if (recipe.complexity === "Hard") {
    tequilaComplexityClass = "hard-text";
  }


  const calculateFirstDivClass = () => {
    switch (recipe.tequilaType) {
      case "Blanco":
        return "Blanco";
      case "Reposado":
        return "Reposado";
      case "Cristalino":
          return "Cristalino";
      default:
        return "default";
    }
  };

  const firstDivClass = calculateFirstDivClass();

  

  return (
    <div className={`recipe${firstDivClass}`}>
      <Grid stackable padded className="recipe">
        <GridRow columns={1} className="recipe-header">
          <GridColumn textAlign="center">
            <h1>
              {recipe.name
                .toLowerCase()
                .split(" ")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")}
            </h1>
            <img className="decorative-heart" src={decorativeHeart} />
          </GridColumn>
          <GridColumn className='cocktail-data' textAlign="center">
            <span className={tequilaComplexityClass}>{recipe.complexity}</span>
            <span className="cocktail-badge">{recipe.typeDrink}</span>
          </GridColumn>
        </GridRow>

        {recipe.enableVideo === "YES" && (
           <GridRow>
            <GridColumn textAlign="center">
              <div className="responsive-iframe-container">
                <iframe
                  title={`${recipe.name} Video`}
                  src={`https://www.youtube.com/embed/${getYoutubeVideoId(
                    recipe.videoAddress
                  )}`}
                  allowFullScreen
                  className="recipe-video"
                ></iframe>
              </div>
              <hr/>
            </GridColumn>
          </GridRow>
        )}

        <GridRow columns={2} className="recipe-image-ingredients" verticalAlign="middle">
          <GridColumn textAlign="center">
            <img className="recipe-image" src={recipe.image} alt={recipe.name} />
          </GridColumn>
          <GridColumn>
            <img className="decorative decorative-up" src={recipeUp} />
              <div className="ingredients-title-container">
                <div>
                  <hr/>
                </div>
                <div>
                  <h2>Ingredients</h2>
                </div>
                <div>
                  <hr/>
                </div>
              </div>
            <ul>
              {recipe.ingredients.map((ingredient, index) => (
                <li key={index}>{ingredient}</li>
              ))}
            </ul>
            <img className="decorative decorative-down" src={recipeDown} />
          </GridColumn>
        </GridRow>

        <GridRow columns={2} className="recipe-prepare" verticalAlign="middle">
          <GridColumn textAlign="center">
            <img src={drinkingRabbit} alt="Driking Rabbit" />
            <h2>How to prepare</h2>
          </GridColumn>
          <GridColumn>
            <ul>
              {recipe.instructions.split('.').map((instruction, index) => (
                <li key={index}>{instruction.trim()}</li>
              ))}
            </ul>
          </GridColumn>
        </GridRow>
        

        {recipe.enableFoodPairing === "YES" && (
          <GridRow columns={1} textAlign="center" className="recipe-pairing">
            <GridColumn>
              <h2>{recipe.FoodPairingTitle}</h2>
              <img src={recipe.FoodPairingImage} alt="Food Pairing"/>
              <p>{recipe.FoodPairingContent}</p>
              <button className="button-link" onClick={() => window.open(recipe.FoodPairingUrl, '_blank')}>
                <span>See How to Prepare</span>
              </button>
              {recipe.enablePDF === "YES" && (
                <div style={{ textAlign: "center" }}>
                  <button className="button-link" onClick={() => window.open(recipe.PDFAddress, '_blank')}>
                    <span>See How to Prepare</span>
                  </button>
                </div>
              )}
            </GridColumn>
          </GridRow>
        )}

        <GridRow className="back-button-row">
          <GridColumn textAlign='center'>
            <Link to={"/"} className="button-small">
                <span>&lt; Back</span>
            </Link>
          </GridColumn>
        </GridRow>

        <hr/>

      </Grid>
    </div>

  );
};

function getYoutubeVideoId(url) {
  const videoIdRegex =
    /(?:v=|\/embed\/|\/\d\/|\/vi\/|youtu\.be\/|\/v\/|\/e\/|\/watch\?v=)([^#\&\?]*).*/;
  const match = url.match(videoIdRegex);
  return match && match[1] ? match[1] : "";
}

export default CocktailPage;